import { Link } from "react-router";
import logoSCA from "@assets/events-awards/logo-sca.png";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_SCA_PATH } from "@events-awards/utils/constants";
import { SCA_FOOTER_MENU } from "@sca/utils/constants";

/**
 * Component to display footer for desktop view in SCA pages
 */
const SCAFooterDesktop = (): React.ReactElement => {
  return (
    <div
      className="grid w-full grid-cols-12 text-center"
      data-testid="sca-footer-desktop-component"
    >
      <div className="col-span-2 pl-0 pr-3">
        <Link to={EVENTS_AWARDS_SCA_PATH} reloadDocument>
          <img
            src={logoSCA}
            alt="Singapore Corporate Awards logo"
            width={124}
            height={166}
          />
        </Link>
      </div>

      <div className="col-span-5 pl-1 pr-3">
        <h3 className="mb-2 text-left font-poppins text-base font-medium">
          About Us
        </h3>

        <p className="text-left leading-normal text-white">
          The Singapore Corporate Awards was launched on 19 September 2005 as
          the umbrella awards for exemplary corporate governance practices for
          listed companies in Singapore. It seeks to consolidate existing awards
          while introducing new awards in the area of excellent corporate
          governance.
        </p>
      </div>

      <div className="col-span-3 px-3">
        <p className="mb-4 text-left font-semibold">Sections</p>

        <div className="my-2 flex flex-row">
          <FooterMenuLinks
            items={SCA_FOOTER_MENU.slice(0, 3)}
            className="space-y-4"
          />

          <FooterMenuLinks
            items={SCA_FOOTER_MENU.slice(3, 6)}
            className="space-y-4 pl-20"
          />
        </div>
      </div>

      <div className="col-span-2 pl-5 pr-3">
        <p className="mb-4 text-left font-semibold">Quick Links</p>

        <FooterMenuLinks
          items={SCA_FOOTER_MENU.slice(6, 9)}
          className="space-y-4"
        />
      </div>
    </div>
  );
};

export default SCAFooterDesktop;
